import {CLASIFICACION_FILTER_INCIDENT_LINKED} from 'src/modules/shared/clasificacionIncidentLinked';
import actions from 'src/modules/tarea/list/tareaListIncidentActions';

const INITIAL_PAGE_SIZE = 10;

const initialData = {
  rows: [] as Array<any>,
  count: 0,
  loading: false,
  filter: {clasificacion: [...CLASIFICACION_FILTER_INCIDENT_LINKED]},
  rawFilter: {clasificacion: [...CLASIFICACION_FILTER_INCIDENT_LINKED]},
  pagination: {
    current: 1,
    pageSize: INITIAL_PAGE_SIZE,
  },
  sorter: {},
  selectedKeys: [] as Array<any>,
  listFilterKey: 0,
};

const tareaListIncidentReducers = (state = initialData, {type, payload}) => {
  if (type === actions.RESETED) {
    return {
      ...initialData,
      filter: {...initialData.filter, ...payload},
      rawFilter: {...initialData.rawFilter, ...payload},
    };
  }

  if (type === actions.TOGGLE_ONE_SELECTED) {
    let selectedKeys = state.selectedKeys;
    const exists = selectedKeys.includes(payload);
    if (exists) {
      selectedKeys = selectedKeys.filter((key) => key !== payload);
    } else {
      selectedKeys = [payload, ...selectedKeys];
    }
    return {...state, selectedKeys};
  }

  if (type === actions.TOGGLE_ALL_SELECTED) {
    const isAllSelected = (state.rows || []).length === (state.selectedKeys || []).length;
    return {
      ...state,
      selectedKeys: isAllSelected ? [] : state.rows.map((row) => row.id),
    };
  }

  if (type === actions.CLEAR_ALL_SELECTED) {
    return {...state, selectedKeys: []};
  }

  if (type === actions.PAGINATION_CHANGED) {
    return {
      ...state,
      pagination: payload || {current: 1, pageSize: INITIAL_PAGE_SIZE},
    };
  }

  if (type === actions.SORTER_CHANGED) {
    return {...state, sorter: payload || {}};
  }

  if (type === actions.SET_HAS_FILTER) {
    return {
      ...state,
      hasFilter: payload ? payload.hasFilter : {},
      filter: payload ? payload.filter : state.filter,
    };
  }

  if (type === actions.SET_PAYLOAD) {
    return {...state, ...payload};
  }

  if (type === actions.FETCH_STARTED) {
    return {
      ...state,
      loading: true,
      selectedKeys: [],
      filter: payload?.filter || state.filter,
      rawFilter: payload?.rawFilter || state.rawFilter,
      pagination:
        payload && payload.keepPagination
          ? state.pagination
          : {current: 1, pageSize: INITIAL_PAGE_SIZE},
    };
  }

  if (type === actions.FETCH_SUCCESS) {
    return {
      ...state,
      loading: false,
      rows: payload.rows,
      count: payload.count,
    };
  }

  if (type === actions.FETCH_ERROR) {
    return {
      ...state,
      loading: false,
      rows: [],
      count: 0,
    };
  }

  return state;
};

export default tareaListIncidentReducers;
